import { logging } from 'gandi.redux-logger';
/**
 * Call handlers based on response status code
 * @param  {Object} handlers Handlers based on status (on200, on2XX, on40X)
 * @param  {Object} store    Redux store
 * @param  {Object} action   Redux action
 * @return {Promise}         Promise with fetcher response
 */
export function processByStatus(handlers
// $FlowFixMe[cannot-resolve-name]
) {
  // $FlowFixMe[cannot-resolve-name]
  const identity = x => x;

  /**
   * Utility function to find all handlers matching
   */
  const getMatchingHandlers = response => {
    const status = `${response.status}`;
    const statuses = ['XXX', `${status.slice(0, -2)}XX`, `${status.slice(0, -1)}X`, status];

    // find the best matching `on` handler
    const onHandler = statuses.reduce((currentHandler, attempt) => {
      if (typeof handlers[`on${attempt}`] === 'function') {
        return handlers[`on${attempt}`];
      }
      return currentHandler;
    }, identity);

    // find all handlers not matching current status
    const notHandlers = Object.keys(handlers).filter(handlerName => {
      // remove non `not` handler
      if (handlerName.substr(0, 3) !== 'not') return false;
      // remove handlers with matching status
      return statuses.indexOf(handlerName.substr(3)) === -1;
    }).map(handlerName => handlers[handlerName]);
    return [onHandler, ...notHandlers];
  };
  return response => Promise.all(getMatchingHandlers(response).map(handler => typeof handler === 'function' ? handler(response) : handler)).then(() => response);
}

/**
 * Default global handlers
 * @type {Object}
 */
const defaultHandlers = logger => action => ({
  onXXX: response => {
    if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
      logger.info({
        type: action.type,
        status: response.status
      }, `action (${action.type}) ` + `did not handle the following status code: ${response.status}`);
    }
  }
});

/**
 * Redux middleware to call fetcher and process handlers based on response
 * status code.
 * @param  {Object}   fetcher
 * @param  {Object}   options Deault handlers based on response status code
 * @param  {Object}   store   Redux store
 * @param  {Function} next    To call next action
 * @param  {Object}   action  Current action called
 * @return {Promise}          fetcher promise
 */
export default function createFetcherMiddleware(fetcher) {
  return createHandlers => store => next => action => {
    if (!action.meta || !action.meta.http) {
      return next(action);
    }
    const payload = action.payload;
    const logger = logging(store.dispatch, 'gandi.redux-fetcher');
    const actionStart = Date.now();
    return payload.fetch(fetcher, store).then(response => {
      const actionTimeElapsed = (Date.now() - actionStart) / 1000;
      logger.info(`${action.type} ${response.url} => ${actionTimeElapsed} sec`);
      return response;
    }).then(processByStatus({
      ...defaultHandlers(logger)(action),
      ...createHandlers(store),
      ...(payload.options || {})
    }));
  };
}